module.exports = __webpack_public_path__ + "img/campus_icon.8a254fe.svg";